export default {
  accessToken: (state) => {
    if (state.auth && state.auth.id) {
      return state.auth.id.accessToken
    }

    return null
  },
  content: (state) => {
    return state.homeContent
  },
  searchResults: (state) => {
    return state.search.searchResults
  },
  getDetails(state) {
    return () => {
      return state.content
    }
  },
  searchTerm(state) {
    return state.search.textInput
  },
  filters(state) {
    return JSON.parse(JSON.stringify(state.search.filters))
  },
  sorting(state) {
    return JSON.parse(JSON.stringify(state.search.sorting))
  },
  pagination(state) {
    return state.search.pagination
  },
  getUserProfile(state) {
    if (state.auth && state.auth.id) {
      return {
        email: state.auth.id.email,
        userName: state.auth.id.name,
        profilePicture: state.auth.id.picture,
        roles: state.auth.id.roles
      }
    }
    return null
  },
  author(state) {
    return state.search.authorFilter.author
  },
  keyword(state) {
    return state.search.keywordFilter.keyword
  },
  mobileFiltersVisibility(state) {
    return state.mobileFiltersVisible
  },
  mostPopularCategory(state) {
    return state.categories.mostPopular
  },
  studentActivitiesCategory(state) {
    return state.categories.studentActivities
  },
  manageYourClassroomCategory(state) {
    return state.categories.manageYourClassRoom
  },
  trySomethingNewCategory(state) {
    return state.categories.trySomethingNew
  },
  featuredContentCategory(state) {
    return state.categories.featuredContent
  },
  standardsContentCategory(state) {
    return state.categories.standardsContent
  },
  topPrimaryContent(state) {
    return state.categories.topPrimary
  },
  topSecondaryContent(state) {
    return state.categories.topSecondary
  },
  featuredPublisherContent(state) {
    return state.categories.featuredPublisherContent
  },
  selectedCategory(state) {
    return state.categories.selectedCategory
  },
  callout(state) {
    return state.callout
  },
  getGrades(state) {
    return JSON.parse(JSON.stringify(state.search.filters))
      .filter(filters => filters.title === 'Grades')[0].items
      .filter((option) => {
        return option.id !== 'all'
      })
  },
  getSubjects(state) {
    return JSON.parse(JSON.stringify(state.search.filters))
      .filter(filters => filters.title === 'Subjects')[0].items
      .filter((option) => {
        return option.id !== 'all'
      })
  },
  getContentTypes(state) {
    return JSON.parse(JSON.stringify(state.search.filters))
      .filter(filters => filters.title === 'Resource Type')[0].items
      .filter((option) => {
        return option.id !== 'all'
      })
  },
  getCountries(state) {
    return JSON.parse(JSON.stringify(state.supportedCountries))
  },
  getLanguages(state) {
    return JSON.parse(JSON.stringify(state.supportedLanguages))
  },
  getStandards(state) {
    return JSON.parse(JSON.stringify(state.search.filters))
      .filter(filters => filters.title === 'Standards')[0].items
  },
  getSearchStrands(state) {
    return JSON.parse(JSON.stringify(state.search.searchResults.strands))
  },
  getStrands(state) {
    return JSON.parse(JSON.stringify(state.search.filters))
      .filter(filters => filters.title === 'Strands')[0].items
  },
  getPendingResources(state) {
    return state.moderation.resources.pending.items
  },
  getPendingResourcesPage(state) {
    return state.moderation.resources.pending.currentPage
  },
  getPendingResourcesLoading(state) {
    return state.moderation.resources.pending.loading
  },
  getPendingResourcesTotal(state) {
    return state.moderation.resources.pending.items.length
  },
  getPendingSelected(state) {
    return state.moderation.resources.pending.selected
  },
  getApprovedResources(state) {
    return state.moderation.resources.approved.items
  },
  getApprovedResourcesPage(state) {
    return state.moderation.resources.approved.currentPage
  },
  getApprovedResourcesLoading(state) {
    return state.moderation.resources.approved.loading
  },
  getApprovedResourcesTotal(state) {
    return state.moderation.resources.approved.items.length
  },
  getApprovedSelected(state) {
    return state.moderation.resources.approved.selected
  },
  getDeclinedResources(state) {
    return state.moderation.resources.declined.items
  },
  getDeclinedResourcesPage(state) {
    return state.moderation.resources.declined.currentPage
  },
  getDeclinedResourcesLoading(state) {
    return state.moderation.resources.declined.loading
  },
  getDeclinedResourcesTotal(state) {
    return state.moderation.resources.declined.items.length
  },
  getDeclinedSelected(state) {
    return state.moderation.resources.declined.selected
  },
  getResourceDataAdded(state) {
    return state.moderation.resources.resourceDataAdded
  },
  hasAdminRole(state) {
    if (state.auth && state.auth.id) {
      if (state.auth.id.roles.includes('role:smarttech.com/cp/admin')) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  },
  getDeclinedResourcesQueueTotal(state) {
    return state.moderationQueue.declined.items.length
  },
  getPendingResourcesQueueTotal(state) {
    return state.moderationQueue.pending.items.length
  },
  getDeclinedResourcesQueue(state) {
    return state.moderationQueue.declined.items
  },
  getPendingResourcesQueue(state) {
    return state.moderationQueue.pending.items
  },
  getPendingQueueSelected(state) {
    return state.moderationQueue.pending.selected
  },
  getDeclinedQueueSelected(state) {
    return state.moderationQueue.declined.selected
  },
  getPendingQueuePage(state) {
    return state.moderationQueue.pending.currentPage
  },
  getDeclinedQueuePage(state) {
    return state.moderationQueue.declined.currentPage
  },
  getPendingQueueLoading(state) {
    return state.moderationQueue.pending.loading
  },
  getDeclinedQueueLoading(state) {
    return state.moderationQueue.declined.loading
  },
  getUserModQueue(state) {
    return state.moderation.resources.queues.items
  },
  getModerationQueue(state) {
    return state.moderationQueue.queues.items
  },
  getFallBackLocale(state) {
    return state.locale.fallbackLocale
  },
  getUserLocation(state) {
    return state.search.userLocation
  },
  getLangLoadStatus(state) {
    return state.langLoadStatus
  },
  getModerationFilters(state) {
    return JSON.parse(JSON.stringify(state.moderationQueue.filters))
  }
}
